export default __webpack_public_path__ + "static/media/foreignPlateIconEmpty.2a593a01.svg";